{
  "nav": {
    "calendaris": "Calendaris",
    "canvisTorn": "Canvis de torn",
    "cobertura": "Cobertura",
    "experts": "Experts i substituts",
    "historial": "Historial",
    "guardiaActual": "Guàrdia actual"
  },
  "titols": {
    "calendaris": "Calendaris de guàrdia",
    "canvisTorn": "Sol·licituds de canvi de torn",
    "cobertura": "Cobertura i buits",
    "experts": "Experts i substituts per servei",
    "historial": "Historial de canvis · Calendaris",
    "guardiaActual": "Qui està de guàrdia",
    "editor": "Editor de calendari"
  },
  "comu": {
    "cancella": "Cancel·la",
    "exporta": "Exporta",
    "carregant": "Carregant…",
    "i": "i",
    "torna": "Torna",
    "desa": "Desa",
    "edita": "Edita"
  },
  "calendaris": {
    "nou": "Nou calendari",
    "duplica": "Duplica",
    "copiaDe": "Còpia de {{nom}}",
    "crea": "Crea calendari",
    "nom": "Nom del calendari",
    "triaAmbit": "Tria departament o àrea",
    "totDepartament": "{{nom}} (tot el departament)",
    "cerca": "Cerca calendari…",
    "total_one": "{{count}} calendari",
    "total_other": "{{count}} calendaris",
    "buit": "No hi ha calendaris",
    "manual": "Manual",
    "recordatoriHores_one": "{{count}} h abans",
    "recordatoriHores_other": "{{count}} h abans",
    "area": "Àrea {{nom}}",
    "departament": "Departament {{nom}}",
    "origen": "Calendari d'origen",
    "triaOrigen": "Tria el calendari a duplicar"
  },
  "columnes": {
    "calendari": "Calendari",
    "ambit": "Àmbit",
    "rotacio": "Tipus de rotació",
    "persones": "Persones",
    "cobertura30": "Cobertura 30 dies",
    "estat": "Estat",
    "recordatori": "Recordatori"
  },
  "periodicitat": {
    "SETMANAL": "Setmanal",
    "QUINZENAL": "Quinzenal",
    "MENSUAL": "Mensual"
  },
  "estatCalendari": {
    "ACTIU": "Actiu",
    "BUITS": "Buits detectats",
    "INSUFICIENT": "Cobertura insuficient",
    "INACTIU": "Inactiu",
    "REVISIO": "En revisió"
  },
  "torn": {
    "nou": "Nou torn",
    "editar": "Editar torn",
    "elimina": "Elimina el torn",
    "desa": "Desa el torn",
    "calendari": "Calendari",
    "inici": "Data i hora d'inici",
    "fi": "Data i hora de fi",
    "titular": "Persona titular",
    "substitut": "Persona de substitució",
    "triaPersona": "Tria una persona",
    "senseSubstitut": "Sense substitut",
    "canals": "Canals de contacte",
    "notes": "Notes",
    "avis": "S'avisarà automàticament {{persones}} en desar els canvis.",
    "ambit": "Àmbit"
  },
  "canals": {
    "PUSH": "Push",
    "EMAIL": "Correu",
    "TRUCADA": "Trucada"
  },
  "editor": {
    "senseCobertura": "Sense cobertura",
    "buit": "Buit",
    "rotacio": "Rotació automàtica",
    "desa_one": "Desa {{count}} canvi",
    "desa_other": "Desa {{count}} canvis",
    "anterior": "Setmana anterior",
    "seguent": "Setmana següent",
    "periode": "{{desde}} — {{fins}}",
    "avui": "Torna a la setmana actual",
    "persona": "Persona",
    "tornDia": "Torn del dia",
    "lletraTitular": "T",
    "lletraSubstitut": "S",
    "disponibles": "Persones disponibles",
    "ajuda": "Arrossega una persona sobre una casella per cobrir el torn, o selecciona-la i fes clic al dia. Si el dia ja té titular, s'assigna com a substitut.",
    "cercaPersona": "Cerca persona",
    "afegeix": "Afegeix {{nom}}",
    "periodeEtiqueta": "Període de la graella",
    "recarrega": "Recarrega",
    "graella": "Graella de torns",
    "senseTorns": "No hi ha torns en aquest període",
    "ambTorns_one": "{{count}} torn en el període",
    "ambTorns_other": "{{count}} torns en el període",
    "senseTorn": "{{area}} · Sense torn assignat"
  },
  "llegenda": {
    "titular": "Titular",
    "substitut": "Substitut",
    "crisi": "Reforç en crisi",
    "senseCobertura": "Sense cobertura"
  },
  "diesCurts": {
    "0": "DL",
    "1": "DT",
    "2": "DC",
    "3": "DJ",
    "4": "DV",
    "5": "DS",
    "6": "DG"
  },
  "diesLlargs": {
    "0": "Dilluns",
    "1": "Dimarts",
    "2": "Dimecres",
    "3": "Dijous",
    "4": "Divendres",
    "5": "Dissabte",
    "6": "Diumenge"
  },
  "rotacio": {
    "titol": "Nova rotació automàtica · {{nom}}",
    "configuracio": "Configuració",
    "periodicitat": "Tipus de repetició",
    "desde": "Data d'inici de vigència",
    "fins": "Data de fi de vigència",
    "senseFi": "Sense data de fi",
    "diaInici": "Dia de canvi de torn",
    "horaCanvi": "Hora d'inici de torn",
    "participants_one": "Participants ({{count}})",
    "participants_other": "Participants ({{count}})",
    "ajudaOrdre": "Arrossega per canviar l'ordre. Cada persona serà titular un període i substituta el següent.",
    "senseParticipants": "Afegeix almenys una persona",
    "puja": "Puja {{nom}}",
    "pujaCurt": "↑",
    "baixa": "Baixa {{nom}}",
    "baixaCurt": "↓",
    "treu": "Treu {{nom}}",
    "treuCurt": "✕",
    "previsualitzacio": "Previsualització",
    "genera": "Genera i previsualitza",
    "confirma": "Confirma i aplica",
    "resum_one": "Es generarà {{count}} torn.",
    "resum_other": "Es generaran {{count}} torns.",
    "conflictes_one": "{{count}} solapament amb torns existents",
    "conflictes_other": "{{count}} solapaments amb torns existents",
    "mes_one": "… i {{count}} torn més",
    "mes_other": "… i {{count}} torns més",
    "ajudaPrevi": "Configura la rotació i genera una previsualització abans d'aplicar-la.",
    "pas1": "1 · Freqüència i vigència",
    "pas2_one": "2 · Ordre de rotació de persones ({{count}})",
    "pas2_other": "2 · Ordre de rotació de persones ({{count}})",
    "titularDe": "Titular · {{nom}}",
    "tornsGenerats": "Torns generats",
    "conflictesDetectats": "Conflictes detectats",
    "cap": "Cap"
  },
  "sollicituds": {
    "pendents_one": "{{count}} pendent",
    "pendents_other": "{{count}} pendents",
    "totes": "Totes",
    "cerca": "Cerca sol·licitud…",
    "buit": "No hi ha sol·licituds",
    "tria": "Selecciona una sol·licitud",
    "detall": "Sol·licitud #{{id}}",
    "sollicitant": "Sol·licitant",
    "tipus": "Tipus",
    "tornAfectat": "Torn afectat",
    "proposat": "Persona proposada",
    "novaFranja": "Nova franja",
    "motiu": "Motiu",
    "data": "Data de la sol·licitud",
    "comentari": "Comentari",
    "ambConflictes_one": "La cobertura resultant té {{count}} solapament.",
    "ambConflictes_other": "La cobertura resultant té {{count}} solapaments.",
    "senseConflictes": "Sense conflictes: {{nom}} no té cap altre torn assignat aquests dies.",
    "denega": "Denega",
    "aprova": "Aprova el canvi",
    "titolTipus": {
      "CANVI": "{{nom}} sol·licita un canvi d'horari",
      "SUBSTITUCIO": "{{nom}} sol·licita substitució",
      "INTERCANVI": "{{nom}} sol·licita un intercanvi"
    },
    "sollicitatEl": "Sol·licitat el {{data}}",
    "titularActual": "Titular actual",
    "substitutActual": "Persona del torn",
    "coberturaResultant": "Cobertura resultant",
    "comentariOpcional": "Comentari (opcional)",
    "comentariPlaceholder": "Afegeix un comentari per a l'historial…"
  },
  "estatSollicitud": {
    "PENDENT": "Pendent",
    "APROVADA": "Aprovada",
    "REBUTJADA": "Denegada",
    "CANCELLADA": "Cancel·lada"
  },
  "tipusSollicitud": {
    "CANVI": "Canvi d'horari",
    "SUBSTITUCIO": "Substitució",
    "INTERCANVI": "Intercanvi"
  },
  "cobertura": {
    "per": {
      "DEPARTAMENT": "Per departament",
      "AREA": "Per àrea"
    },
    "mitjana": "Cobertura mitjana",
    "calendaris": "Calendaris",
    "buits": "Buits detectats",
    "diesSense": "Dies sense cobertura",
    "mapa": "Mapa de calor · pròxims {{dies}} dies",
    "buit": "No hi ha calendaris per mostrar",
    "alertes_one": "Alertes de cobertura",
    "alertes_other": "Alertes de cobertura",
    "senseAlertes": "No hi ha buits de cobertura",
    "resol": "Obre el calendari",
    "ambit": "Àmbit",
    "ajustat_one": "Cobertura ajustada el dia {{dies}}.",
    "ajustat_other": "Cobertura ajustada els dies {{dies}}.",
    "senseTitular": "Sense titular:"
  },
  "nivellCobertura": {
    "COBERT": "Cobert",
    "AJUSTAT": "Ajustat",
    "SENSE": "Sense cobertura"
  },
  "experts": {
    "cerca": "Cerca servei…",
    "total_one": "{{count}} servei",
    "total_other": "{{count}} serveis",
    "buit": "No hi ha serveis",
    "servei": "Servei",
    "area": "Àrea responsable",
    "titular": "Tècnic expert",
    "substitut": "Substitut",
    "circuit": "Circuit d'escalat",
    "confirmacio": "Confirmació",
    "senseExpert": "Sense expert",
    "senseSubstitut": "Sense substitut",
    "perDefecte": "Per defecte",
    "circuitDefecte": "Circuit per defecte",
    "edita": "Edita experts de {{servei}}",
    "especialitat": "Especialitat",
    "igual": "Una persona no pot aparèixer dues vegades a la llista.",
    "minuts_one": "{{count}} min",
    "minuts_other": "{{count}} min",
    "mes_one": "+{{count}}",
    "mes_other": "+{{count}}",
    "nouServei": "Nou servei",
    "senseExperts": "Aquest servei encara no té cap tècnic expert.",
    "persona": "Persona {{n}}",
    "tipusFila": "Rol de la persona {{n}}",
    "treu": "Treu la persona {{n}}",
    "afegeixTitular": "Afegeix tècnic expert",
    "afegeixSubstitut": "Afegeix substitut",
    "calTitular": "Cal almenys un tècnic expert titular."
  },
  "historial": {
    "data": "Data i hora",
    "autor": "Autor",
    "torn": "Torn afectat",
    "anterior": "Valor anterior",
    "nou": "Valor nou",
    "motiu": "Motiu",
    "sistema": "Sistema",
    "tots": "Tots els calendaris",
    "equip": "Només el meu equip",
    "total_one": "{{count}} canvi",
    "total_other": "{{count}} canvis",
    "buit": "No hi ha canvis registrats",
    "filtreCalendari": "Calendari: tots"
  },
  "accioHistorial": {
    "CREAR": "Creació",
    "MODIFICAR": "Modificació",
    "ELIMINAR": "Eliminació",
    "ROTACIO": "Rotació automàtica",
    "CANVI_APROVAT": "Canvi aprovat"
  },
  "guardia": {
    "instant": "Actualitzat {{hora}}",
    "buit": "No hi ha guàrdies configurades",
    "area": "Àrea",
    "tecnic": "Tècnic de guàrdia",
    "cobertura": "Cobertura",
    "senseTecnic": "Sense tècnic de guàrdia",
    "substitut": "Substitut: {{nom}}",
    "senseSubstitut": "Sense substitut",
    "fins": "fins {{hora}}",
    "coberta": "Coberta",
    "senseCobertura": "Sense cobertura"
  },
  "tipusRotacio": {
    "SETMANAL": "Setmanal rotativa",
    "QUINZENAL": "Quinzenal rotativa",
    "MENSUAL": "Mensual per torns fixos",
    "MANUAL": "Torns manuals"
  }
}
